import React from "react"
import { graphql } from "gatsby"
import Layout from "gatsby-theme-blank/src/components/Layout/layout"
import SEO from "gatsby-theme-blank/src/components/seo"
import {
  actualiteContentFooter,
  actualiteContentFooterBack,
} from "./styles/detailsActu.module.scss"
import {
  contenuLibreContainer,
  pageContenuLibre,
  actualiteTitle,
  editButton,
} from "./styles/detailsContenuLibre.module.scss"
import ContentTransformer from "gatsby-theme-blank/src/components/Transformers/content-transformer"
import PropTypes from "prop-types"
import {
  ActuTitle,
  ActualiteFooterContainer,
} from "./styled-components/actualite-styled"
import TransitionFade from "gatsby-theme-blank/src/components/transition-fade"
import Ariane from "gatsby-theme-blank/src/components/Ariane/ariane"
import SocialPanel from "gatsby-theme-blank/src/components/SocialMedias/social-panel"
import EditButton from "gatsby-theme-blank/src/components/EditButton/edit-button"

//-----------------------QueryGraphql---------------------------//

export const query = graphql`
  query ($slug: String!) {
    nodeContenuLibre(path: { alias: { eq: $slug } }) {
      ...ContenuLibreNewThemeItem
    }
  }
`

//-----------------------QueryGraphql---------------------------//

//-----------------------Parent component---------------------------//

const ContenuLibreTemplate = ({ data, location }) => {
  const nodeContenuLibre = data.nodeContenuLibre

  return (
    <Layout isDetail={true}>
      <SEO
        title={nodeContenuLibre.title}
        description={
          "Dans cette page, vous découvrez le contenu libre suivant : " +
          nodeContenuLibre.title
        }
      />
      <div className={pageContenuLibre}>
        <Ariane isDetail={true} postName={nodeContenuLibre.title} />
        <div className={contenuLibreContainer}>
          <ActuTitle className={actualiteTitle}>
            <EditButton
              link={"/node/" + nodeContenuLibre.drupal_internal__nid + "/edit"}
              addedClass={editButton}
            />
            {nodeContenuLibre.title}
          </ActuTitle>
          <ContentTransformer content={nodeContenuLibre.body?.processed} />
          <ContenuLibreContentFooter
            nodeContenuLibre={nodeContenuLibre}
            location={location.href}
          />
        </div>
      </div>
    </Layout>
  )
}

//-----------------------Parent component---------------------------//

//-----------------------Child component/ContentFooter---------------------------//

const ContenuLibreContentFooter = ({ nodeContenuLibre, location }) => (
  <>
    <ActualiteFooterContainer className={actualiteContentFooter}>
      <div className={actualiteContentFooterBack}>
        <TransitionFade arialabel="Retour à l'accueil" link="/">
          Retour à l&apos;accueil
        </TransitionFade>
      </div>
      <div>
        <SocialPanel location={location} postData={nodeContenuLibre} />
      </div>
    </ActualiteFooterContainer>
  </>
)

//-----------------------Child component/ContentFooter---------------------------//

//-----------------------Styled component---------------------------//

//-----------------------Styled component---------------------------//

//-----------------------Prop-Types---------------------------//

ContenuLibreTemplate.propTypes = {
  data: PropTypes.object.isRequired,
  location: PropTypes.object,
}
ContenuLibreContentFooter.propTypes = {
  nodeContenuLibre: PropTypes.object.isRequired,
  location: PropTypes.object,
}

//-----------------------Prop-Types---------------------------//

export default ContenuLibreTemplate
